module.exports = __webpack_public_path__ + "static/media/dots_texture_768_109@3x.b68cc124.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/usecases/dots_texture_768_109@3x.png
// module id = 1277
// module chunks = 0